import { useEffect, useState } from "react";
import { AlertTriangle, X } from "lucide-react";
import api from "../lib/api";

const DISMISS_KEY = "ss_worker_banner_dismissed";

export default function WorkerStatusBanner({ isAuthenticated }) {
  const [status, setStatus] = useState(null);
  const [dismissed, setDismissed] = useState(() => {
    try {
      return sessionStorage.getItem(DISMISS_KEY) === "1";
    } catch {
      return false;
    }
  });

  useEffect(() => {
    if (!isAuthenticated) {
      setStatus(null);
      return undefined;
    }
    let cancelled = false;
    const load = async () => {
      try {
        const r = await api.get("/jobs/worker-status");
        if (!cancelled) setStatus(r.data);
      } catch {
        if (!cancelled) setStatus(null);
      }
    };
    load();
    const id = setInterval(load, 30000);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, [isAuthenticated]);

  const show =
    isAuthenticated &&
    !dismissed &&
    status &&
    status.backend === "celery" &&
    !status.alive;

  if (!show) return null;

  const message = !status.redis
    ? "Redis is not running. Start it (redis-server) or use ./backend/scripts/run_backend.sh — fetches will fail until then."
    : "Background worker is not running. Start it with ./backend/scripts/run_backend.sh or ./backend/scripts/run_worker.sh — fetches will sit queued until then.";

  const dismiss = () => {
    setDismissed(true);
    try {
      sessionStorage.setItem(DISMISS_KEY, "1");
    } catch {
      /* ignore */
    }
  };

  return (
    <>
      <div className="h-10" aria-hidden />
      <div className="fixed top-16 left-0 right-0 z-40 border-b border-amber-300 bg-amber-50 text-amber-950 dark:border-amber-700 dark:bg-amber-950/90 dark:text-amber-100">
        <div className="container mx-auto flex items-center gap-3 px-4 py-2 text-sm">
          <AlertTriangle className="h-4 w-4 shrink-0" />
          <p className="flex-1">{message}</p>
          <button
            type="button"
            onClick={dismiss}
            className="rounded p-1 hover:bg-amber-200/60 dark:hover:bg-amber-800/60"
            aria-label="Dismiss worker warning"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </>
  );
}
